import * as React from 'react'
import { Brandy as StyledBrandy } from '../Brandy/Brandy.styles'
import * as Styled from './Stack.styles'

const Stack = ({
  children,
  alignMainContent = 'left',
  excluded = [],
  spaceDisclaimers = false,
  spacing = 'md',
}) => (
  <Styled.Stack
    className="leshen-stack"
    spacing={spacing}
    excluded={spaceDisclaimers ? excluded : [...excluded, StyledBrandy]}
    alignMainContent={alignMainContent}
  >
    {children}
  </Styled.Stack>
)

export default Stack
